module.exports = __webpack_public_path__ + "img/Banner1中文.8fd56739.png";